import $ from 'jquery';

export function dropdown() {
  $(document).ready(function() {
    $('.nav-right__link').on('click', function(e) {
      $('.nav-right__dropdown.active').not($(this).next('.nav-right__dropdown')).removeClass('active');      
      $(this).next('.nav-right__dropdown').toggleClass('active');
      e.stopPropagation();
    });
    
    $(document).on('click', function() {
      $('.nav-right__dropdown').removeClass('active');
    });
  });

  // Modulos
  $(document).ready(function() {
    $('.mobile__modules').on('click', function(e) {
      $('.sidebar-nav').toggleClass('expanded-mobile');
      $('.sidebar-nav__rail').toggleClass('active');
      e.stopPropagation();
    });

    // Evitar que clics dentro del rail propaguen al document
    $('.sidebar-nav__rail').on('click', function(e) {
      e.stopPropagation();
    });

    // Cerrar el rail al hacer clic fuera de él
    $(document).on('click', function() {
      $('.sidebar-nav__rail').removeClass('active');
      $('.sidebar-nav').removeClass('expanded-mobile');
    });

    // Cerrar el rail al hacer clic en un link del menú
    $(document).on('click', '.sidebar-nav__rail .sidebar__link', function() {
      $('.sidebar-nav__rail').removeClass('active');
      $('.sidebar-nav').removeClass('expanded-mobile');
    });

    // Cerrar el rail al hacer clic en el botón toggle interno del rail
    $(document).on('click', '.sidebar-nav__rail .sidebar__toggle', function(e) {
      e.stopPropagation();
      $('.sidebar-nav__rail').removeClass('active');
      $('.sidebar-nav').removeClass('expanded-mobile');
    });
  });

}